import { AdyenResultStatus } from '../../../types/adyenResultStatus.enum'

export const successfulPaymentStatuses = [
    AdyenResultStatus.AUTHORISED,
    AdyenResultStatus.PAID,
    AdyenResultStatus.RECEIVED
]

export const allowedPaymentStatuses = [
    AdyenResultStatus.AUTHORISED,
    AdyenResultStatus.PAID,
    AdyenResultStatus.RECEIVED,
    AdyenResultStatus.REFUSED
]
